<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <div class="InputPassengers" v-if="lineClassDay">
      <div class="title">
        <div class="name">
          <span>{{ lineClassDay.StartNodeName }}</span> 开往
          <span>{{ lineClassDay.ArrivalNodeName }}</span>
        </div>
        <div class="row">
          <div class="date">{{ lineClassDay.ClassDate }}</div>
          <div class="time">{{ lineClassDay.ClassTime }} 发车</div>
        </div>
      </div>

      <!-- 版本一： -->
      <!-- <van-grid
        :column-num="2"
        :gutter="10"
        clickable
        style="margin-bottom: 10px"
        :center="false"
      >
        <van-grid-item
          @click="ticketTypeClick(1)"
          :class="{ active: selectTicketType == 1 }"
          v-if="lineClassDay.FullPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>全</van-col>
            <van-col span="8" style="color: red"
              >{{ FullTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.FullPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            type="success"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{ lineClassDay.CanSaleCount }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(2)"
          :class="{ active: selectTicketType == 2 }"
          v-if="lineClassDay.HalfPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>半</van-col>
            <van-col span="8" style="color: red"
              >{{ HalfTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.HalfPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            :type="lineClassDay.HalfPrice ? 'success' : 'danger'"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
          >
            余位:{{
              lineClassDay.HalfPrice ? lineClassDay.CanSaleCount : "不可售"
            }}
          </van-tag>
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(3)"
          :class="{ active: selectTicketType == 3 }"
          v-if="lineClassDay.OfferPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>优</van-col>
            <van-col span="8" style="color: red"
              >{{ OfferTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.OfferPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            :type="lineClassDay.OfferPrice ? 'success' : 'danger'"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{
              lineClassDay.OfferPrice ? lineClassDay.OverOffer : "不可售"
            }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(0)"
          :class="{ active: selectTicketType == 0 }"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>免</van-col>
            <van-col span="8" style="color: red">{{ FreeTicketNum }}张</van-col>
            <van-col span="12" style="color: #ffb870">￥0</van-col>
          </van-row>
          <van-tag
            mark
            :type="lineClassDay.OverChild > 0 ? 'success' : 'danger'"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{ lineClassDay.OverChild }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(4)"
          :class="{ active: selectTicketType == 4 }"
          v-if="lineClassDay.StationFee"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="8" style>站务</van-col>
            <van-col span="8" style="color: red"
              >{{ StationTicketNum }}张</van-col
            >
            <van-col span="8" style="color: #ffb870"
              >￥{{ lineClassDay.StationFee }}</van-col
            >
          </van-row>
          <van-tag
            mark
            :type="lineClassDay.StationFee ? 'success' : 'danger'"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{
              lineClassDay.StationFee ? lineClassDay.CanSaleCount : "不可售"
            }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(5)"
          :class="{ active: selectTicketType == 5 }"
          v-if="lineClassDay.RoundTripPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>双程</van-col>
            <van-col span="8" style="color: red"
              >{{ RoundTripTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.RoundTripPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            type="success"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{ lineClassDay.CanSaleCount }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(6)"
          :class="{ active: selectTicketType == 6 }"
          v-if="lineClassDay.BackTripPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>回程</van-col>
            <van-col span="8" style="color: red"
              >{{ BackTripTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.BackTripPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            type="success"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{ lineClassDay.CanSaleCount }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(7)"
          :class="{ active: selectTicketType == 7 }"
          v-if="lineClassDay.StudentPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>学生</van-col>
            <van-col span="8" style="color: red"
              >{{ StudentTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.StudentPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            type="success"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{ lineClassDay.CanSaleCount }}</van-tag
          >
        </van-grid-item>

        <van-grid-item
          @click="ticketTypeClick(8)"
          :class="{ active: selectTicketType == 8 }"
          v-if="lineClassDay.MilitaryOrDisabilityPrice"
        >
          <van-row style="font-size: 0.5rem">
            <van-col span="4" style>军残</van-col>
            <van-col span="8" style="color: red"
              >{{ MilitaryOrDisabilityPriceTicketNum }} 张</van-col
            >
            <van-col span="12" style="color: #ffb870"
              >￥{{ lineClassDay.MilitaryOrDisabilityPrice }}</van-col
            >
          </van-row>
          <van-tag
            mark
            type="success"
            style="margin-top: 0.1rem; width: 50%; text-align: left"
            >余位:{{ lineClassDay.CanSaleCount }}</van-tag
          >
        </van-grid-item>
      </van-grid> -->

      <div class="ticket-type">
        <div
          v-for="(item, index) in ticketTypeRightList"
          :key="index"
          v-show="handlerTicketTypeDisplay(item)"
          @click="ticketTypeClick(item)"
          class="ticket-type-item"
          :class="[
            {
              'ticket-type-is-checked': !item.isChecked,
              'item-active': selectTicketType === item.RightTarget,
            },
          ]"
        >
          <div class="ticket-type-item-blank"></div>
          <div class="ticket-type-item-info">
            <div class="ticket-type-item-detail">
              <span>{{ item.label }}</span>
              &nbsp;
              <span style="color: red;">
                {{ handlerInputTicketNumber(item.ticketNumBinding) }} 张
              </span>
              &nbsp;
              <span style="color: #f8823c;">
                ￥{{ lineClassDay[item.priceBinding] || 0 }}
              </span>
            </div>
            <div class="ticket-type-item-residue">
              余位：{{ lineClassDay[item.residueSeatBinding] }}
            </div>
          </div>
        </div>
      </div>

      <van-tabs v-bind:swipeable="true" color="#FFB870" v-model="active">
        <van-tab class="checkCar" title="刷卡录入">
          <p>正在录入旅客信息......</p>
          <p>将旅客证件放在设备上录入信息</p>
          <p>请放置证件</p>
        </van-tab>
        <van-tab class="handle" title="手动录入">
          <div class="title">请录入购买车票的旅客信息</div>
          <div class="block">
            <div class="row">
              <label for>
                <span>证件类型</span>
                <select v-model="passengerCardType">
                  <option value="居民身份证">居民身份证</option>
                  <option value="港澳台证件">港澳台证件</option>
                  <option value="护照">护照</option>
                  <option value="外国人永居证">外国人永居证</option>
                  <option value="其它">其它</option>
                </select>
              </label>
            </div>
            <div class="row" style="position: relative;">
              <label for="carNum">
                <span>证件号码</span>
                <input
                  id="carNum"
                  v-model="passengerCardNumber"
                  placeholder="请填写证件号码"
                />
              </label>
              <div class="btn-ocr" @click="ocrShow = true">
                拍照识别
              </div>
            </div>
            <div class="row">
              <label for="name">
                <span>旅客姓名</span>
                <input
                  id="name"
                  v-model="passengerName"
                  placeholder="请填写旅客姓名"
                  autocomplete="off"
                />
              </label>
            </div>
            <div class="row">
              <label for="phoneNum">
                <span>联系电话</span>
                <input
                  id="phoneNum"
                  v-model="phoneNum"
                  placeholder="请填写联系电话"
                  autocomplete="off"
                />
              </label>
            </div>
            <van-field
              style="font-size: 0.4rem; padding: 0.1rem 0.2rem;"
              label-width="4em"
              label-align="left"
              v-model="buyTicketNum"
              type="number"
              label="购买张数"
              placeholder="请填写购买张数"
            />
            <div class="row">
              <label for="remark">
                <span>车票备注</span>
                <input
                  id="remark"
                  v-model="remark"
                  placeholder="请输入订单明细备注"
                  autocomplete="off"
                />
              </label>
            </div>
          </div>
          <div class="btnWrap">
            <div v-on:click="resetInfo" class="reset">重置</div>
            <div v-on:click="passengerSubmit" class="add">录入</div>
          </div>
        </van-tab>
      </van-tabs>
      <!-- 旅客信息 -->
      <div class="passengerInfo">
        <div class="title">
          旅客信息
          <span class="title-2">是否开启打印</span>
          <van-switch
            class="switch"
            active-color="#2891e7"
            inactive-color="#ccc"
            v-model="isOpenPrint"
            size=".5rem"
          />
        </div>
        <div class="wrap">
          <div
            v-for="(item, index) of passengerInfoList"
            v-bind:key="item.id"
            class="block"
          >
            <div class="left">{{ item.ticketTypeName }}</div>
            <div class="right">
              <span>{{ item.CardType }}</span>
              <span>{{ item.CardNum }}</span>
              <span>{{ item.passengerName }}</span>
            </div>
            <span
              @click="deletePassenger(index)"
              class="iconfont iconshanchu delete"
            ></span>
          </div>
        </div>
        <div class="bottom">
          <label for="orderSource">
            <span>订单来源：</span>
            <input
              id="orderSource"
              type="text"
              readonly
              v-model="orderSource"
              @click="showOrderSourcePicker = true"
              autocomplete="off"
            />
            <van-popup
              v-model="showOrderSourcePicker"
              round
              position="bottom"
              close-on-click-overlay
            >
              <van-picker
                show-toolbar
                :columns="orderSourceNameList"
                :default-index="orderSourceIndex"
                @cancel="showOrderSourcePicker = false"
                @confirm="onOrderSourceListConfirm"
              />
            </van-popup>
          </label>
          <label for="allMoney">
            <span>总金额：</span>
            <input id="allMoney" disabled type="text" v-model="allMoney" autocomplete="off" />
          </label>
          <label for="payCode">
            <span>支付码：</span>
            <input
              disabled
              id="payCode"
              @focus="payCodeState = true"
              @blur="payCodeState = false"
              type="text"
              v-model="payCode"
            />
          </label>
          <label for="phoneReservation">
            <span>电话预定：</span>
            <input
              id="phoneReservation"
              @focus="phoneFocusState = true"
              @blur="phoneFocusState = false"
              type="text"
              v-model="phoneReservation"
              autocomplete="off"
            />
          </label>
          <div class="btnWrap">
            <div
              @click="sweepCode"
              :class="CashReceiptRight ? 'sweepCode' : 'sweepCode disabled'"
            >
              <span>扫码支付</span>
            </div>
            <div
              v-show="isAllowCashPay"
              @click="cashPayFunc"
              :class="ScanCodePaymentRight ? 'cash' : 'cash disabled'"
            >
              <span>现金支付</span>
            </div>
            <div
              @click="bookPayFunc"
              :class="ReserveTelRight ? 'cash' : 'cash disabled'"
            >
              <span>电话预定</span>
            </div>
            <div @click="cancelSaleTicket" class="cancel">
              <span>取消售票</span>
            </div>
          </div>
        </div>
        <div id="canvasImgDiv" ref="canvasImgDiv">
          <canvas id="canvasImg"></canvas>
        </div>
      </div>
      <div class="seatList">
        <div class="title">
          座位表
          <van-switch
            class="switch"
            active-color="#2891e7"
            inactive-color="#ccc"
            v-model="seatDisplayState"
            size=".5rem"
          />
        </div>
        <div v-if="seatDisplayState" class="SeatList">
          <div class="container">
            <div
              @click="selectSeat(index)"
              v-for="(item, index) of originSeatData"
              v-bind:key="item.id"
              :style="[SeatDataStyles[index]]"
              :class="{
                current: item.selectedState == 'current',
              }"
            >
              <div class="top" style="font-size: 18px; color: red;">
                <span class="index">{{ index + 1 }}</span>
                <span>{{ item.seatTicketTypeName }}</span>
              </div>
              <div class="bottom" style="font-size: 14px; color: red;">
                <span class="startNodeName">{{ item.StartNodeName }}</span>
                <span class="arrivalNodeName">{{ item.ArrivalNodeName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 上一笔售票明细 -->
      <div
        @click="lastSaleDetailsClick('show')"
        v-if="pagefrom != 'TicketCheck'"
        class="lastSaleDetails"
      >
        上一笔售票明细
      </div>
      <!-- 上一笔售票明细弹出层 -->
      <div>
        <van-popup
          v-model="SaleDetailsShow"
          position="center"
          :overlay="true"
          class="SaleDetailsShow"
        >
          <van-tabs
            v-bind:swipeable="true"
            color="#FFB870"
            v-model="SaleDetailsActive"
          >
            <van-tab
              class="SaleDetailsShowTab"
              v-for="(item, index) of lastSaleDetailsList"
              :key="item.id"
              :title="JSON.stringify(index + 1)"
            >
              <div>
                <div>
                  <span class="left">订单代码</span>
                  <span class="right">{{ item.OrderNo }}</span>
                </div>
                <div>
                  <span class="left">线路名称</span>
                  <span class="right">{{ item.LineName }}</span>
                </div>
                <div>
                  <span class="left">班次日期</span>
                  <span class="right">{{ item.ClassDate }}</span>
                </div>
                <div>
                  <span class="left">班次时间</span>
                  <span class="right">{{ item.ClassTime }}</span>
                </div>
                <div>
                  <span class="left">上车点名称</span>
                  <span class="right">{{ item.StartNodeName }}</span>
                </div>
                <div>
                  <span class="left">下车点名称</span>
                  <span class="right">{{ item.ArrivalNodeName }}</span>
                </div>
                <div>
                  <span class="left">座位号</span>
                  <span class="right">{{ item.SeatNo }}</span>
                </div>
                <div>
                  <span class="left">票型</span>
                  <span class="right">{{ item.TicketTypeName }}</span>
                </div>
                <div>
                  <span class="left">票价</span>
                  <span class="right">{{ item.TicketPrice }}</span>
                </div>
                <div>
                  <span class="left">车票状态</span>
                  <span class="right">{{ item.TicketStatusName }}</span>
                </div>
                <div>
                  <span class="left">实付金额</span>
                  <span class="right">{{ item.PayPrice }}</span>
                </div>
                <div>
                  <span class="left">乘车人姓名</span>
                  <span class="right">{{ item.CustName }}</span>
                </div>
                <div>
                  <span class="left">乘车人证件类型</span>
                  <span class="right">{{ item.CustCertType }}</span>
                </div>
                <div>
                  <span class="left">乘车人证件号码</span>
                  <span class="right">{{ item.CustCertNo }}</span>
                </div>
                <div>
                  <span class="left">乘车人电话</span>
                  <span class="right">{{ item.CustTel }}</span>
                </div>
                <div>
                  <span class="left">是否包含儿童</span>
                  <span class="right">
                    {{ item.IsChild == true ? "是" : "否" }}
                  </span>
                </div>
                <div>
                  <span class="left">儿童姓名</span>
                  <span class="right">{{ item.ChildName }}</span>
                </div>
                <div>
                  <span class="left">儿童证件类型</span>
                  <span class="right">{{ item.ChildCertType }}</span>
                </div>
                <div>
                  <span class="left">儿童证件号码</span>
                  <span class="right">{{ item.ChildCertNo }}</span>
                </div>
                <div>
                  <span class="left">条码</span>
                  <span class="right">{{ item.BarCode }}</span>
                </div>
                <div>
                  <span class="left">备注</span>
                  <span class="right">{{ item.Remark }}</span>
                </div>
                <div>
                  <span class="left">修改人代码</span>
                  <span class="right"></span>
                </div>
                <div>
                  <span class="left">修改人姓名</span>
                  <span class="right"></span>
                </div>
                <div>
                  <span class="left">修改时间</span>
                  <span class="right"></span>
                </div>
                <div>
                  <span class="left">创建人代码</span>
                  <span class="right">{{ item.CreateCode }}</span>
                </div>
                <div>
                  <span class="left">创建人姓名</span>
                  <span class="right">{{ item.CreateName }}</span>
                </div>
                <div>
                  <span class="left">创建时间</span>
                  <span class="right"></span>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="repeatPrint">
            <span @click="rePrint">复打</span>
            <span @click="lastSaleDetailsClick('refresh')" class="refresh"
              >刷新</span
            >
          </div>
        </van-popup>
      </div>
    </div>

    <!-- OCR身份识别 -->
    <van-popup
      v-model="ocrShow"
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <p style="margin: 0.6rem 0;">请选择身份证相片</p>
      <van-uploader
        class="uploadBox"
        :after-read="OCRRead"
        accept="image/*"
        style="text-align: center;"
      />
    </van-popup>

    <!-- 粤康码，穗康码信息展示 -->
    <health-info ref="healthInfo" :isSaveHealthInfo="false"></health-info>
  </div>
</template>

<script>
var speechOnAudio = new Audio();
speechOnAudio.src = require("../../img/ding.mp3");
speechOnAudio.volume = 1; //取值范围[0-1]
import Header from "@/components/Header/Header.vue";
import healthInfo from "@/components/healthInfo.vue";

export default {
  components: {
    Header,
    "health-info": healthInfo,
  },
  data() {
    return {
      title: "录入旅客", //标题
      lineClassDay: null, //班次信息

      active: 0, // 选项卡默认选中第一个
      passengerCardNumber: "", // 证件号码
      passengerName: "", // 乘客姓名
      buyTicketNum: 1, // 购买票的张数
      phoneNum: "", // 联系电话
      remark:"",//订单明细备注
      passengerCardType: "居民身份证", // 证件类型
      CodeSign: 1, //
      selectTicketType: "", // 选中的票的类型 --- 全、半、优、免
      selectTicketTypeName: "全", // 选中的票的类型名称 --- 全、半、优、免
      selectTicketTypeNum: "",
      seatTicketTypeName: "", // 座位表格右上角显示

      FullTicketNum: 0, // 录入的全票张数
      HalfTicketNum: 0, // 录入的半票张数
      OfferTicketNum: 0, // 录入的优惠票张数
      FreeTicketNum: 0, // 录入的免费票张数
      StationTicketNum: 0, //录入的站务票

      RoundTripTicketNum: 0, // 录入的双程票张数
      BackTripTicketNum: 0, // 录入的回程票张数
      StudentTicketNum: 0, // 录入的学生票张数
      MilitaryOrDisabilityPriceTicketNum: 0, // 录入的军残票张数
      CustomPriceTicketNum: 0, // 录入的自定义票张数

      CardInfo: "", //身份证信息
      passengerInfoList: [], // 录入的旅客信息列表
      adultList: [], // 录入旅客中包含的成人列表
      childList: [], // 录入旅客中包含的孩童列表
      allMoney: 0, // 总金额
      payCode: "", // 支付码
      payCodeState: false, // 支付码文本框是否聚焦
      phoneReservation: "", // 电话预定
      phoneFocusState: false, // 电话预定的文本框是否聚焦
      seatData: [], // 座位数据,
      originSeatData: [], // 初始座位数据
      SeatNo: [], // 座位号
      SeatDataStyles: [], // 座位样式
      seatDisplayState: false, // 座位表的显示状态
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      SaleDetailsShow: false, // 售票明细详情弹出层的显示状态
      lastSaleDetailsList: [], // 上一次售票明细
      SaleDetailsActive: 0, // 售票明细选项卡
      printObj: {}, // 打印票据的内容

      pagefrom: this.$route.query.from, //从哪个页面过来
      isOpenPrint: false, //是否开启打印
      isAllowCashPay: this.$utils.getSysParams("IsAllowCashPay") != "0", //是否允许现金支付
      CashReceiptRight:
        this.$utils.getRight("Sys.view.SellTicket.Container", "CashReceipt") ===
        true, // 现金支付权限
      ScanCodePaymentRight:
        this.$utils.getRight(
          "Sys.view.SellTicket.Container",
          "ScanCodePayment"
        ) === true, // 扫码支付权限
      ReserveTelRight:
        this.$utils.getRight("Sys.view.SellTicket.Container", "ReserveTel") ===
        true, // 电话预订权限

      PassengerListKey: "",
      ocrShow: false,
      orderSourceList: [], // 订单来源列表
      orderSourceNameList: [], // 订单来源名称列表
      orderSource: "", // 订单来源
      orderSourceCode: "", // 订单来源代码
      showOrderSourcePicker: false, // 显示订单来源选择
      orderSourceIndex: 0, // 默认选中索引

      IsEnableSaleShowHealthInfo:
        this.$utils.getSysParams("IsEnableSaleShowHealthInfo") === "1", // 是否启用健康码信息展示

      ticketTypeRightList: [
        {
          label: "全",
          RightTarget: 1,
          rightCode: "IsAllowInputFullTicket",
          isChecked: true,
          ticketNumBinding: "FullTicketNum",
          priceBinding: "FullPrice",
          residueSeatBinding: "CanSaleCount",
        },
        {
          label: "半",
          RightTarget: 2,
          rightCode: "IsAllowInputHalfTicket",
          isChecked: true,
          ticketNumBinding: "HalfTicketNum",
          priceBinding: "HalfPrice",
          residueSeatBinding: "CanSaleCount",
        },
        {
          label: "优惠",
          RightTarget: 3,
          rightCode: "IsAllowInputOfferTicket",
          isChecked: true,
          ticketNumBinding: "OfferTicketNum",
          priceBinding: "OfferPrice",
          residueSeatBinding: "OverOffer",
        },
        {
          label: "免",
          RightTarget: 0,
          rightCode: "IsAllowInputFreeTicket",
          isChecked: true,
          ticketNumBinding: "FreeTicketNum",
          priceBinding: "",
          residueSeatBinding: "OverChild",
        },
        {
          label: "站务",
          RightTarget: 4,
          rightCode: "IsAllowInputStationTicket",
          isChecked: true,
          ticketNumBinding: "StationTicketNum",
          priceBinding: "StationFee",
          residueSeatBinding: "CanSaleCount",
        },
        {
          label: "双程",
          RightTarget: 5,
          rightCode: "IsAllowInputRoundTripTicket",
          isChecked: true,
          ticketNumBinding: "RoundTripTicketNum",
          priceBinding: "RoundTripPrice",
          residueSeatBinding: "CanSaleCount",
        },
        {
          label: "回程",
          RightTarget: 6,
          rightCode: "IsAllowInputBackTripTicket",
          isChecked: true,
          ticketNumBinding: "BackTripTicketNum",
          priceBinding: "BackTripPrice",
          residueSeatBinding: "CanSaleCount",
        },

        {
          label: "学生",
          RightTarget: 7,
          rightCode: "IsAllowInputStudentTicket",
          isChecked: true,
          ticketNumBinding: "StudentTicketNum",
          priceBinding: "StudentPrice",
          residueSeatBinding: "CanSaleCount",
        },
        {
          label: "军残",
          RightTarget: 8,
          rightCode: "IsAllowInputMilitaryOrDisabilityTicket",
          isChecked: true,
          ticketNumBinding: "MilitaryOrDisabilityPriceTicketNum",
          priceBinding: "MilitaryOrDisabilityPrice",
          residueSeatBinding: "CanSaleCount",
        },
        {
          label: "自定义",
          RightTarget: 11,
          rightCode: "IsAllowInputCustomPriceTicket",
          isChecked: true,
          ticketNumBinding: "CustomPriceTicketNum",
          priceBinding: "CustomPrice",
          residueSeatBinding: "CanSaleCount",
        },
      ],
    };
  },
  computed: {
    // 处理显示票类型
    handlerTicketTypeDisplay: () => {
      return function (item) {
        if (this.lineClassDay[item.priceBinding] || item.RightTarget === 0) {
          return true;
        }
        return false;
      };
    },
    // 处理显示录入票数
    handlerInputTicketNumber: () => {
      return function (item) {
        return this[item];
      };
    },
  },
  methods: {
    // 获取录入票类型权限
    getTicketTypeRight() {
      this.ticketTypeRightList.forEach((item) => {
        item.isChecked = this.$utils.getRight(
          "Sys.view.SellTicket.Container",
          item.rightCode
        );
      });
    },

    // 选择票的类型
    ticketTypeClick(item) {
      // console.log("item", item.isChecked);
      if (!item.isChecked) return;
      let index = item.RightTarget;
      this.selectTicketType = index;
      switch (index) {
        case 1:
          this.selectTicketTypeName = "全";
          this.selectTicketTypeNum = this.lineClassDay.FullPrice;
          break;
        case 2:
          if (this.lineClassDay.HalfPrice > 0) {
            this.selectTicketTypeName = "半";
            this.selectTicketTypeNum = this.lineClassDay.HalfPrice;
          } else {
            this.$toast("该类票未设置价格，无法出票，请选择其它类票");
          }
          break;
        case 3:
          if (this.lineClassDay.OfferPrice > 0) {
            this.selectTicketTypeName = "优";
            this.selectTicketTypeNum = this.lineClassDay.OfferPrice;
          } else {
            this.$toast("该类票未设置价格，无法出票，请选择其它类票");
          }
          break;
        case 0:
          this.selectTicketTypeName = "免";
          this.selectTicketTypeNum = 0;
          break;
        case 4:
          this.selectTicketTypeName = "站务";
          this.selectTicketTypeNum = this.lineClassDay.StationFee;
          break;
        case 5:
          if (this.lineClassDay.RoundTripPrice > 0) {
            this.selectTicketTypeName = "双程";
            this.selectTicketTypeNum = this.lineClassDay.RoundTripPrice;
          } else {
            this.$toast("该类票未设置价格，无法出票，请选择其它类票");
          }
          break;
        case 6:
          this.selectTicketTypeName = "回程";
          this.selectTicketTypeNum = this.lineClassDay.BackTripPrice;
          break;
        case 7:
          if (this.lineClassDay.StudentPrice > 0) {
            this.selectTicketTypeName = "学生";
            this.selectTicketTypeNum = this.lineClassDay.StudentPrice;
          } else {
            this.$toast("该类票未设置价格，无法出票，请选择其它类票");
          }
          break;
        case 8:
          if (this.lineClassDay.MilitaryOrDisabilityPrice > 0) {
            this.selectTicketTypeName = "军残";
            this.selectTicketTypeNum = this.lineClassDay.MilitaryOrDisabilityPrice;
          } else {
            this.$toast("该类票未设置价格，无法出票，请选择其它类票");
          }
          break;
        case 11:
          if (this.lineClassDay.CustomPrice > 0) {
            this.selectTicketTypeName = "自定义";
            this.selectTicketTypeNum = this.lineClassDay.CustomPrice;
          } else {
            this.$toast("该类票未设置价格，无法出票，请选择其它类票");
          }
          break;
      }
    },
    // 录入
    passengerSubmit() {
      this.passengerName = this.passengerName.replace(/\s+/g, "");
      this.phoneNum = this.phoneNum.replace(/\s+/g, "");
      this.passengerCardNumber = this.passengerCardNumber.replace(/\s+/g, "");
      var msg = "";
      msg = this.$utils.checkCardNo(this.passengerCardNumber, this.CodeSign);
      if (isNaN(this.buyTicketNum)) {
        this.$toast("购票张数必须输入整数");
        return;
      }
      let buyTicketNumInt = parseInt(this.buyTicketNum);

      if (this.CodeSign != 4) {
        // 不为'其它'时
        if (msg != "") {
          // 证件号码验证
          this.$toast(msg);
          this.passengerCardNumber = "";
        } else if (!this.$utils.isName(this.passengerName)) {
          // 乘客姓名判断
          this.$toast("请输入正确的姓名");
        } else if (!this.$utils.isPhone(this.phoneNum)) {
          // 手机号判断
          this.$toast("请输入正确的手机号");
        } else if (isNaN(this.buyTicketNum)) {
          // 购票张数判断
          this.$toast("购票张数必须输入整数");
        } else if (buyTicketNumInt > 100 || buyTicketNumInt < 1) {
          // 购票张数判断
          this.$toast("购票张数必须为1~100的整数");
        } else {
          for (var i = 0; i < buyTicketNumInt; i++) {
            this.inputInfo();
          }
        }
      } else if (buyTicketNumInt > 100 || buyTicketNumInt < 1) {
        // 购票张数判断
        this.$toast("购票张数必须为1~100的整数");
      } else {
        for (var j = 0; j < buyTicketNumInt; j++) {
          this.inputInfo();
        }
      }
    },
    // 读取乘客信息缓存
    getPassengerInfoListCache() {
      var passengerListText = window.localStorage.getItem(
        this.PassengerListKey
      );
      var passengerList = JSON.parse(passengerListText || "[]");
      // 计算总金额
      this.allMoney = 0;
      for (var i = 0; i < passengerList.length; i++) {
        this.allMoney += passengerList[i].ticketTypeNum;
      }
      this.allMoney = this.allMoney.toFixed(2);
      return passengerList;
    },
    // 将录入乘客信息写入缓存
    setPassengerInfoListCache(passengerInfoList) {
      window.localStorage.setItem(
        this.PassengerListKey,
        JSON.stringify(passengerInfoList)
      );
    },
    // 删除乘客信息缓存（售票后使用）
    removePassengerInfoListCache() {
      window.localStorage.removeItem(this.PassengerListKey);
    },
    // OCR识别身份证
    OCRRead(file) {
      // 大于1.5MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1500000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 400;
          canvas.height = 300;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
             如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 400, 300);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          this.OCRQuery(file);
        };
        return;
      }
      this.OCRQuery(file);
    },
    OCRQuery(file) {
      this.$http
        .post(
          this.$api.IDCardOcr,
          this.$qs.stringify({
            model: {
              imgBase64: file.content,
              cardSide: true,
            },
            type: "CLOcr",
          })
        )
        .then((res) => {
          if (res.success) {
            this.passengerCardType = "居民身份证";
            this.passengerName = res.data.Name;
            this.passengerCardNumber = res.data.IdNum;
          }
          this.ocrShow = false;
        });
    },
    // 录入方法
    inputInfo() {
      var CardType = this.passengerCardType;
      var CardNum = this.passengerCardNumber;
      var passengerName = this.passengerName;
      var obj = {
        ticketType: this.selectTicketType,
        ticketTypeName: this.selectTicketTypeName,
        ticketTypeNum: this.selectTicketTypeNum,
        CardType: CardType,
        CardNum: CardNum,
        passengerName: passengerName,
        isCheckCard: false,
        CustTel: this.phoneNum,
        Remark:this.remark
      };
      if (this.selectTicketType == 2 && this.lineClassDay.HalfPrice <= 0) {
        this.$toast("该类型票价为0，无法录入");
      } else if (
        this.selectTicketType == 3 &&
        this.lineClassDay.OfferPrice <= 0
      ) {
        this.$toast("该类型票价为0，无法录入");
      } else {
        this.passengerInfoList.push(obj);
      }

      this.allMoney = 0;
      for (var i = 0; i < this.passengerInfoList.length; i++) {
        this.allMoney += this.passengerInfoList[i].ticketTypeNum;
      }
      this.allMoney = this.allMoney.toFixed(2);

      this.onShowHealthCode([
        {
          CustCertNo: obj.CardNum,
          CustName: obj.passengerName,
          CustCertType: obj.CardType,
        },
      ]);
    },
    // 重置按钮点击事件
    resetInfo() {
      this.passengerCardNumber = "";
      this.passengerName = "";
      this.phoneNum = "";
      this.buyTicketNum = 1;
      this.remark="";
    },
    // 放置证件录入旅客信息 , 扫码
    readInfo() {
      if (window.framework) {
        // 打开扫描
        if (window.framework.isReadScanner) {
          window.framework.isReadScanner(true);
        }

        //开启NFC模块
        if (window.framework.isReadCard) {
          window.framework.isReadCard(true);
        }

        var fun = function (jsonObj) {
          //读取失败
          if (!jsonObj.success) {
            this.$toast.fail("身份证读取失败！");
            return;
          }
          this.CardInfo = jsonObj.data;

          var obj = {
            ticketType: this.selectTicketType,
            ticketTypeName: this.selectTicketTypeName,
            ticketTypeNum: this.selectTicketTypeNum,
            CardType: "居民身份证",
            CardNum: this.CardInfo["身份号码"],
            passengerName: this.CardInfo["姓名"],
            isCheckCard: true,
          };

          this.passengerInfoList.push(obj);
          this.allMoney = 0;
          for (var i = 0; i < this.passengerInfoList.length; i++) {
            this.allMoney += this.passengerInfoList[i].ticketTypeNum;
          }
          this.allMoney = this.allMoney.toFixed(2);

          this.onShowHealthCode([
            {
              CustCertNo: obj.CardNum,
              CustName: obj.passengerName,
              CustCertType: obj.CardType,
            },
          ]);
        };
        var nfcFun = function (ReqId, AndroidID) {
          console.log("AndroidID:" + AndroidID);
          //读取失败
          if (!ReqId) {
            this.$toast.fail("身份证读取失败！");
            return;
          }
          speechOnAudio.play();
          //调动后端接口获取身份信息
          this.$http
            .post(
              this.$api.getIdCardCloudDecode,
              this.$qs.stringify({ ReqId: ReqId, AndroidID: AndroidID })
            )
            .then((res) => {
              if (res.success) {
                //alert('获取身份证信息成功')
                //alert(JSON.stringify(res.data))
                //将身份信息转为CardInfo对象
                let jsonObj = {
                  success: res.success,
                  data: {
                    姓名: res.data.Name,
                    身份号码: res.data.IdNum,
                    //照片: res.data.Picture
                  },
                };
                //存在NFC提示信息，则需要确认
                //每天每个班次设备首次操作才进行提示
                let _nfc_alertTime = JSON.parse(
                  window.localStorage.getItem("_nfc_alertTime")
                );
                let isNeedAlert = false;
                if (_nfc_alertTime) {
                  let lastAlertTime = _nfc_alertTime.alertTime;
                  isNeedAlert = this.$moment(lastAlertTime).isBefore(
                    this.$moment(new Date()).format("YYYY-MM-DD")
                  );
                  if (!isNeedAlert) {
                    if (
                      _nfc_alertTime.classList.indexOf(
                        this.lineClassDay.GID.toLowerCase()
                      ) == -1
                    ) {
                      isNeedAlert = true;
                    }
                  } else {
                    _nfc_alertTime.classList = "";
                  }
                } else {
                  isNeedAlert = true;
                }
                if (res.msg && isNeedAlert) {
                  window.localStorage.setItem(
                    "_nfc_alertTime",
                    JSON.stringify({
                      alertTime: this.$moment(new Date()).format("YYYY-MM-DD"),
                      classList:
                        this.lineClassDay.GID.toLowerCase() +
                        "," +
                        (_nfc_alertTime ? _nfc_alertTime.classList : ""),
                    })
                  );
                  this.$dialog
                    .alert({
                      message: res.msg,
                    })
                    .then(() => {
                      fun.bind(this)(jsonObj);
                    });
                } else {
                  fun.bind(this)(jsonObj);
                }
              }
            });
        };
        //NFC读取身份证
        window.callJSIdCardCloudDecode = nfcFun.bind(this);
        //读取身份证回调
        window.callJSPersonInfo = fun.bind(this);
      }
      //扫码枪回调
      var JsscanBack = function (code) {
        //扫码失败
        if (code == "" || code == null || code.length == 0) {
          this.$toast.fail("扫码失败！");
          return;
        } else {
          // 扫码后 -- 创建订单 -- 支付 -- 打印
          if (this.passengerInfoList.length < 1) {
            this.$toast("不存在购票旅客信息,请确认");
          } else {
            this.payCode = code;
            if (this.payCode) {
              this.createTicketOrder("toPay");
            }
          }
        }
      };
      // 扫码枪回调
      window.callJSScan = JsscanBack.bind(this);
      // 相机扫码回调
      window.callCameraScan = JsscanBack.bind(this);
    },
    // 删除该旅客的录入信息
    deletePassenger(index) {
      this.passengerInfoList.splice(index, 1);
      this.allMoney = 0;
      for (var i = 0; i < this.passengerInfoList.length; i++) {
        this.allMoney += this.passengerInfoList[i].ticketTypeNum;
      }
      this.allMoney = this.allMoney.toFixed(2);
    },
    // 扫码支付
    sweepCode() {
      if (this.passengerInfoList.length < 1) {
        this.$toast("不存在购票旅客信息,请确认");
      } else if (!this.ScanCodePaymentRight) {
        this.$toast("没有扫码支付权限");
      } else {
        this.$utils
          .scanQRCode()
          .then((res, type) => {
            console.log("扫码回调", res, type);
            var a = res.resultStr;
            this.scanCreateTicket(a);
          })
          .catch((err) => {
            this.$toast(err);
          });
      }
      // var that = this;
      // if (this.passengerInfoList.length < 1) {
      //   this.$toast("不存在购票旅客信息,请确认");
      // } else if (!this.ScanCodePaymentRight) {
      //   this.$toast("没有扫码支付权限");
      // } else {
      //   if (window.framework && window.framework.jsCameraScan) {
      //     window.framework.jsCameraScan();
      //     return;
      //   } else {
      //     if (this.$utils.getIsWxClient()) {
      //       wx.ready(function () {
      //         wx.scanQRCode({
      //           needResult: 1,
      //           scanType: ["qrCode"],
      //           success: function (t) {
      //             var a = t.resultStr;
      //             // that.scanCreateTicket(a);
      //             window.callCameraScan(a);
      //           },
      //           fail: function (e) {
      //             alert(e);
      //           },
      //         });
      //       });
      //     } else {
      //       this.$toast("调起扫码失败，请检查设备！");
      //       return;
      //     }
      //   }
      //   // 扫码支付--光标定位到支付码框
      //   document.getElementById("payCode").disabled = false;
      //   document.getElementById("payCode").focus();
      //   this.$toast("请输入支付码后按回车键");
      // }
    },
    // 扫码支付订单
    scanCreateTicket(scanResult) {
      //扫码失败
      if (scanResult == "" || scanResult == null || scanResult.length == 0) {
        this.$toast.fail("扫码失败！");
        return;
      } else {
        // 扫码后 -- 创建订单 -- 支付 -- 打印
        if (this.passengerInfoList.length < 1) {
          this.$toast("不存在购票旅客信息,请确认");
        } else {
          this.payCode = scanResult;
          if (this.payCode) {
            this.createTicketOrder("toPay");
          }
        }
      }
    },
    // 现金支付
    cashPayFunc() {
      if (this.passengerInfoList.length < 1) {
        this.$toast("请先录入旅客信息!");
      } else if (!this.CashReceiptRight) {
        this.$toast("没有现金支付权限");
      } else {
        if (
          this.lineClassDay.OperateCompGID.toLowerCase() !=
            this.OperObj.CompGID.toLowerCase() &&
          this.$utils.getSysParams("WindowAgentSaleIsAllowCashPay") != "1"
        ) {
          this.$toast("代售班次不支持现金支付，如需开启请联系客服");
          return;
        } else {
          this.createTicketOrder("cashPay");
        }
      }
    },
    //上车支付（电话预定）
    bookPayFunc() {
      if (this.$utils.getSysParams("WindowSaleIsAllowTelReservation") === "0") {
        this.$toast("已设置不允许电话预定，如需开启请联系客服");
        return;
      }
      if (this.passengerInfoList.length < 1) {
        this.$toast("请先录入旅客信息!");
      } else if (!this.ReserveTelRight) {
        this.$toast("没有电话预定权限");
      } else {
        if (this.phoneReservation) {
          if (!this.$utils.isPhone(this.phoneReservation)) {
            this.$toast("请输入正确的十一位手机号码");
            return false;
          }
          this.createTicketOrder("book");
        } else {
          if (this.phoneNum) {
            this.phoneReservation = this.phoneNum;
            this.createTicketOrder("book");
          } else {
            for (var i = 0; i < this.passengerInfoList.length; i++) {
              if (!this.passengerInfoList[i].isCheckCard) {
                this.$toast("订单存在非刷卡录入旅客，必须输入联系人号码!");
                return false;
              }
            }
            this.createTicketOrder("book");
          }
        }
      }
    },
    // 创建订单
    createTicketOrder(state, checkContactTel) {
      var PassengerJsonText = [];
      var childNum = this.childList.length;
      for (var i = 0; i < this.passengerInfoList.length; i++) {
        if (this.passengerInfoList[i].ticketTypeName != "免") {
          // 不等于免童
          PassengerJsonText.push({
            TicketType: this.passengerInfoList[i].ticketType,
            CustName: this.passengerInfoList[i].passengerName,
            CustTel: this.passengerInfoList[i].CustTel,
            CustCertType: this.passengerInfoList[i].CardType,
            CustCertNo: this.passengerInfoList[i].CardNum,
            IsChild: null,
            ChildName: "",
            ChildCertType: "",
            ChildCertNo: "",
            SeatNo: this.SeatNo.length > 0 ? this.SeatNo[i] : null,
            Remark:this.passengerInfoList[i].Remark
          });
        }

        if (this.passengerInfoList[i].ticketTypeName == "免") {
          for (var j = 0; j < PassengerJsonText.length; j++) {
            if (!PassengerJsonText[j].IsChild && childNum > 0) {
              PassengerJsonText[j].IsChild = 1;
              PassengerJsonText[j].ChildName = this.passengerInfoList[
                i
              ].passengerName;
              PassengerJsonText[j].ChildCertType = this.passengerInfoList[
                i
              ].CardType;
              PassengerJsonText[j].ChildCertNo = this.passengerInfoList[
                i
              ].CardNum;
              childNum--;
            }
          }
        }
      }

      let OrderTypeID = 1;
      if (state == "book") {
        OrderTypeID = 2;
      } else {
        OrderTypeID = 1;
      }
      //如果设置了参数WindowSaleIsMustInputTel 必须录入手机号码
      if (this.$utils.getSysParams("WindowSaleIsMustInputTel") === "1") {
        if (!this.phoneReservation && !this.phoneNum) {
          this.$toast("已设置要求录入旅客联系电话，必须输入联系人号码!");
          return false;
        }
      }
      if (this.phoneReservation) {
        if (!this.$utils.isPhone(this.phoneReservation)) {
          this.$toast("请输入正确的十一位手机号码");
          return false;
        }
      }
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.lineClassDay.StartNodeGID,
        ArrivalNodeGID: this.lineClassDay.ArrivalNodeGID,
        PassengerJsonText: JSON.stringify(PassengerJsonText),
        ContactName: this.passengerName,
        ContactTel: this.phoneReservation
          ? this.phoneReservation
          : this.phoneNum,
        OrderTypeID: OrderTypeID, // 1 代表扫码支付
        WeiXinOpenID: null,
        WeiXinAppID: null,
        AttachJsonText: JSON.stringify({
          OrderSource: this.orderSourceCode, // 订单来源
        }),
        OperGID: this.OperObj.GID, //操作员GID
        OperCode: this.OperObj.UserCode, //操作员代码
        OperName: this.OperObj.UserName, //操作员名称
        CheckContactTel:
          typeof checkContactTel == "undefined" || checkContactTel == true,
      };
      this.$http
        .post(this.$api.createTicketOrder, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            // 订单创建成功后删除乘客信息缓存
            this.removePassengerInfoListCache();

            let obj = res.data[0];
            let extendObj = JSON.parse(obj.ExtendObject || "{}");
            if (extendObj.IsShowConfirm) {
              this.$dialog
                .confirm({
                  title: "操作提示",
                  message: extendObj.ConfirmMsg,
                })
                .then(() => {
                  this.createTicketOrder(state, false);
                });
              return;
            }

            // 是否从TicketCheck过来的
            if (this.pagefrom == "TicketCheck" && state == "book") {
              this.$router.push({
                path: "TicketCheck",
                query: {
                  from: "InputPassengers",
                },
              });
              return;
            }

            // 现金 -- 提交    扫码 -- 支付
            if (state == "toPay") {
              // 扫码支付 --- 创建订单后
              // 支付订单 -- 扫码
              this.TicketOrderPayDo(
                "AllinpayScanPayBSC",
                res.data[0].OrderNo,
                this.payCode,
                res.data
              );
            } else if (state == "cashPay") {
              // 现金支付 --- 创建订单后
              // 支付订单 -- 现金
              this.TicketOrderPayDo(
                "CashPay",
                res.data[0].OrderNo,
                null,
                res.data
              );
            }
            this.$toast("订单创建成功");
          } else {
            this.payCode = "";
            if (res.msg && res.msg[0] == "[") {
              let errorObj = JSON.parse(res.msg)[0];
              // 未支付不弹窗直接跳转历史订单页面
              if (!errorObj.PaySuccessTime) {
                window.localStorage.setItem("historyOrder", res.msg);
                this.$router.push({
                  path: "/HistoryOrder",
                });
              }
            }
          }
        })
        .catch((err) => {
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },

    // 支付订单
    TicketOrderPayDo(PayTypeCode, OrderNo, payCode) {
      let params = {
        PayTypeCode: PayTypeCode,
        OrderNo: OrderNo,
        OperGID: this.OperObj.GID, //操作员GID
        OperCode: this.OperObj.UserCode, //操作员代码
        OperName: this.OperObj.UserName, //操作员名称
      };
      this.$http
        .post(
          this.$api.onTicketOrderPayDo,
          this.$qs.stringify({
            model: params,
            authcode: payCode,
          })
        )
        .then((res) => {
          if (res.success) {
            this.$toast("支付成功");
            //如果是从检票页面过来的直接跳转回去
            //跳转回去后直接检对应的车票
            if (this.pagefrom == "TicketCheck") {
              let orderlist = [];
              res.data.forEach((t) => {
                if (t.CustCertNo && t.CustName) {
                  orderlist.push(t);
                }
              });
              this.$router.push({
                name: "TicketCheck",
                params: {
                  from: "InputPassengers",
                  checkList: orderlist,
                },
              });
              return;
            }
            // 这里打印的是支付成功后，再获取上一次售票明细的数据
            this.lastSaleDetailsClick("print");
            setTimeout(() => {
              let data = this.lastSaleDetailsList;
              if (data.length < 1) {
                this.$toast("未获取到数据");
              } else {
                this.$toast("请稍等，正在准备打印");
              }
              this.onPrintTicket(data);
            }, 1200);
            // 支付成功后回退页面(直接调取消售票的方法)
            this.$router.back(-1);
          } else {
            // this.$toast(res);
          }
        })
        .catch((err) => {
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    /**
     * 展示粤康码
     */
    onShowHealthCode(ticketList) {
      let idCardTicketList = ticketList.filter((i) => {
        return i.CustCertType == "居民身份证";
      });
      // alert(JSON.stringify({
      //   '是否APP': window.framework != undefined,
      //   '是否设置参数': this.IsEnableSaleShowHealthInfo,
      //   '筛选票列表': idCardTicketList,
      //   '票列表': ticketList
      // }))
      // 展示粤康码/穗康码（仅在APP环境下），并且系统参数设置“是否启用健康码信息展示”为启用，并且证件类型为居民身份证
      if (
        window.framework &&
        this.IsEnableSaleShowHealthInfo &&
        idCardTicketList.length > 0
      ) {
        this.$refs.healthInfo.$emit("show", ticketList);
        return true;
      }
      return false;
    },

    //  取消售票
    cancelSaleTicket() {
      //公用页面 返回前一页
      this.removePassengerInfoListCache();
      this.$router.back(-1);
      // this.$router.push({
      //   name: 'LineClassDaySaleQuery',
      //   path: "LineClassDaySaleQuery",
      //   params: {
      //   }
      // });
    },
    //打印票据
    onPrintTicket(obj) {
      //找到画布的元素
      if (!window.framework) {
        this.$toast.fail("请在手持机上开启打印功能");
        return;
      }
      // JSON 格式数据
      var jsonArray = [];
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].IsChild) {
          obj[i].IsChild = "(携童)";
        } else {
          obj[i].IsChild = "";
        }
        if (!obj[i].Berth) {
          obj[i].Berth = "";
        }
        var log = "(定制巴士)";
        if ([1, 2].indexOf(this.customMadeLevel) == -1) {
          log = "";
        }
        jsonArray.push([
          {
            type: 1,
            size: 2,
            data: "" + obj[i].PrintTitleName + "",
          },
          {
            type: 1,
            data:
              "           " +
              log +
              "\n" +
              obj[i].StartNodeName +
              "→" +
              obj[i].ArrivalNodeName +
              "\n票    号：" +
              obj[i].BarCode +
              "\n发车时间：" +
              obj[i].ClassDate +
              " " +
              obj[i].ClassTime +
              "\n检票卡位：" +
              (obj[i].Gate ? obj[i].Gate : "") +
              "\n班    次：" +
              obj[i].ClassCode +
              (this.$utils.getSysParams("IsPrintSeatNo") == "0"
                ? ""
                : "\n座    位：" + obj[i].SeatNo) +
              "\n票    价：" +
              obj[i].PayPrice +
              "\n车    型：" +
              obj[i].VehicleTypeName +
              "\n",
          },
          {
            type: 2,
            data: "" + obj[i].BarCode + "",
          },
          {
            type: 1,
            data:
              "" +
              obj[i].CustName +
              "  " +
              obj[i].CustCertNo +
              "" +
              obj[i].IsChild +
              "\n\n注意事项：\n1.乘车凭证当日当次有效\n2.开发票请扫描下方二维码\n3.珍惜生命，乘车请您系好安全带\n4.开具电子发票需在发车" +
              obj[i].InvoiceTime +
              "小时后\n",
          },
          {
            type: 3,
            data: "" + obj[i].TicketInvoiceAddress + "",
          },
          {
            type: 1,
            data: "\n\n",
          },
        ]);
        if (obj[i].IsCanApplyTax == "1") {
          // 显示发票申请时间
          jsonArray[i][3] = {
            type: 1,
            data:
              "" +
              obj[i].CustName +
              "  " +
              obj[i].CustCertNo +
              "" +
              obj[i].IsChild +
              "\n\n注意事项：\n1.乘车凭证当日当次有效\n2.开发票请扫描下方二维码\n3.珍惜生命，乘车请您系好安全带\n4.开具电子发票需在发车" +
              obj[i].InvoiceTime +
              "小时后\n",
          };
        } else if (obj[i].IsCanApplyTax == "0") {
          // 不显示发票申请时间 不显示二维码
          jsonArray[i][3] = {
            type: 1,
            data:
              "" +
              obj[i].CustName +
              "  " +
              obj[i].CustCertNo +
              "" +
              obj[i].IsChild +
              "\n\n注意事项：\n1.乘车凭证当日当次有效\n2.珍惜生命，乘车请您系好安全带\n",
          };
          jsonArray[i].splice(4, 1);
        }
      }
      var screenJsonArray = [];
      jsonArray.forEach((item) => {
        item.forEach((childItem) => {
          screenJsonArray.push(childItem);
        });
      });

      if (window.framework.jsPrintJsonData) {
        window.framework.jsPrintJsonData(JSON.stringify(screenJsonArray));
      } else {
        this.$toast("该手持机不支持的打印方法");
      }
    },
    // 复打
    rePrint() {
      this.lastSaleDetailsClick("print");
      setTimeout(() => {
        let data = this.lastSaleDetailsList;
        if (data.length < 1) {
          this.$toast("未获取到数据");
        } else {
          this.$toast("请稍等，正在准备打印");
        }
        var printArr = [];
        for (var i = 0; i < data.length; i++) {
          printArr.push(data[i]);
        }
        this.onPrintTicket(printArr);
      }, 1200);
    },
    // 获取座位数据
    getLineClassSeatMapQuery() {
      let params = {
        ClassGID: this.lineClassDay.GID,
      };
      this.$http
        .post(this.$api.getLineClassSeatMapQuery, this.$qs.stringify(params))
        .then((res) => {
          this.seatData = JSON.parse(JSON.stringify(res.data));
          this.originSeatData = JSON.parse(JSON.stringify(res.data));
          for (var i = 0; i < this.originSeatData.length; i++) {
            this.SeatDataStyles.push({
              background: this.originSeatData[i].CssStyle.split(";")[0].split(
                ":"
              )[1],
            });
            if (
              this.originSeatData[i].TicketTypeName == "全价" &&
              this.originSeatData[i].IsChild == true
            ) {
              this.originSeatData[i].seatTicketTypeName = "全+童";
            } else if (
              this.originSeatData[i].TicketTypeName == "儿童价" &&
              this.originSeatData[i].IsChild == false
            ) {
              this.originSeatData[i].seatTicketTypeName = "儿";
            } else if (
              this.originSeatData[i].TicketTypeName == "儿童价" &&
              this.originSeatData[i].IsChild == true
            ) {
              this.originSeatData[i].seatTicketTypeName = "儿+童";
            } else {
              this.originSeatData[i].seatTicketTypeName = this.originSeatData[
                i
              ].TicketTypeName;
            }
          }
        })
        .catch((err) => {
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    //获取班次数据
    getLineClassDaySaleQuery() {
      let params = {
        GID: this.$route.query.GID,
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"),
        StartNodeGID: this.$route.query.StartNodeGID,
        ArrivalNodeGID: this.$route.query.ArrivalNodeGID,
        ClassDate: this.$route.query.ClassDate,
        OperGID: this.OperObj.GID,
      };
      this.$http
        .post(this.$api.getLineClassDaySaleQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success && res.data.length > 0) {
            this.lineClassDay = res.data[0];
            this.getLineClassSeatMapQuery();
            // 默认选中有权限的第一项
            const firstType = this.ticketTypeRightList.find(
              (type) => type.isChecked
            );
            firstType && this.ticketTypeClick(firstType);
            // this.ticketTypeClick(1);
          } else {
            this.$dialog
              .alert({
                title: "提示",
                message: "获取班次数据失败！" + res.msg,
              })
              .then(() => {
                this.$router.back(-1);
              });
          }
        })
        .catch((err) => {
          this.$dialog
            .alert({
              title: "提示",
              message: err,
            })
            .then(() => {
              this.$router.back(-1);
            });
        });
    },
    // 上一笔售票明细按钮点击事件
    lastSaleDetailsClick(state) {
      if (state == "print" || state == "refresh") {
        this.$http
          .post(this.$api.lastSaleDetails)
          .then((res) => {
            if (res.success) {
              this.lastSaleDetailsList = JSON.parse(JSON.stringify(res.data));
            }
          })
          .catch((err) => {
            this.$dialog.alert({
              title: "提示",
              message: err,
            });
          });
      } else if (state == "show") {
        this.$http
          .post(this.$api.lastSaleDetails)
          .then((res) => {
            if (res.success) {
              this.lastSaleDetailsList = res.data;
              this.SaleDetailsShow = true;
            }
          })
          .catch((err) => {
            this.$dialog.alert({
              title: "提示",
              message: err,
            });
          });
      }
    },
    // 选择座位
    selectSeat(index) {
      this.originSeatData = [];
      // for (var i = 0; i < this.seatData.length; i++) {
      //   this.seatData[i].selectedState = ''
      // }
      // 多选
      if (
        !this.seatData[index].selectedState ||
        this.seatData[index].selectedState == ""
      ) {
        this.seatData[index].selectedState = "current";
        this.SeatNo.push(this.seatData[index].SeatNo);
        this.SeatNo = [...new Set(this.SeatNo)];
      } else {
        this.seatData[index].selectedState = "";
        for (var i = 0; i < this.SeatNo.length; i++) {
          if (this.SeatNo[i] == index + 1) {
            this.SeatNo.splice(i, 1);
          }
        }
      }
      this.originSeatData = this.seatData;
    },
    // 查询订单来源
    getOrderSourceQuery: function () {
      var that = this;
      this.$http
        .post(this.$api.CompanyOrderSourceQuery)
        .then((res) => {
          if (res.success) {
            this.orderSourceList = res.data;
            this.orderSourceNameList = this.orderSourceList.map(
              (item) => item.SourceName
            );
            var index = this.orderSourceList.findIndex((item) => {
              if (item.SysUserGID == that.OperObj.GID) {
                return true;
              }
            });
            if (index != -1) {
              this.orderSource = this.orderSourceList[index].SourceName;
              this.orderSourceCode = this.orderSourceList[index].SourceCode;
              this.orderSourceIndex = index;
            }
          }
        })
        .catch((err) => {
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    onOrderSourceListConfirm: function (value, index) {
      this.orderSource = value;
      this.orderSourceCode = this.orderSourceList[index].SourceCode;
      this.showOrderSourcePicker = false;
    },
    /**
     * 健康码关闭事件回调
     */
    doHealthInfoClose() {
      // 返回上一级页面
      // setTimeout(() => {
      //   this.$router.back(-1);
      // }, 500);
    },
  },
  mounted() {
    if (!this.$route.query.GID) {
      this.$router.back(-1);
      return;
    }
    if (window.framework) {
      this.isOpenPrint =
        window.localStorage.getItem("isOpenPrint") == "true" ? true : false;

      // 定义关闭健康码事件回调
      this.$on("onHealthInfoClose", this.doHealthInfoClose);
    } else {
      this.isOpenPrint = false;
    }
    // this.startName = window.sessionStorage.getItem("StartSelectedName");
    // this.arrivalName = window.sessionStorage.getItem("ArrivalSelectedName");
    this.active = parseInt(
      window.localStorage.getItem("PassengersActive")
        ? window.localStorage.getItem("PassengersActive")
        : 0
    );
    this.passengerCardType = window.localStorage.getItem("PassengerCardType")
      ? window.localStorage.getItem("PassengerCardType")
      : "居民身份证";
    this.getOrderSourceQuery();
    this.getLineClassDaySaleQuery();
    this.readInfo();
    if (window.framework) {
      //兼容新手持机
      if (this.isOpenPrint) {
        //判断方法是否存在 // 连接打印机
        if (window.framework.isReadPrint) {
          window.framework.isReadPrint(true);
        }
      }
    }
    this.PassengerListKey = this.$route.query.GID + "PassengerList";
    this.passengerInfoList = this.getPassengerInfoListCache();
    var that = this;
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        if (that.phoneFocusState) {
          // 是否聚焦于电话预定文本框
          //  聚焦 --- 必须输入联系人号码 --- 创建订单
          if (!that.phoneReservation) {
            that.$toast("电话预定必须输入联系人号码!");
          } else {
            if (that.passengerInfoList.length < 1) {
              that.$toast("请先录入旅客信息!");
            } else {
              that.createTicketOrder();
            }
          }
        } else {
          //  失焦
        }

        if (that.payCodeState) {
          // 聚焦于支付码框，判断是否为空，为空则聚焦到电话预定框
          if (that.payCode == "") {
            document.getElementById("payCode").blur();
            document.getElementById("phoneReservation").focus();
          } else {
            // 正则判断 payCode
            var patt =
              /^1[012345]\d{16}$/.test(that.payCode) ||
              /^2[56789]\d{14,22}$/.test(that.payCode) ||
              /^30\d{13,21}$/.test(that.payCode);
            if (patt) {
              that.createTicketOrder("toPay");
            } else {
              that.$toast("您输入的支付码有误");
            }
          }
        } else {
          //  失焦
        }
      }
    };
  },

  watch: {
    //是否开启打印修改
    isOpenPrint() {
      if (!window.framework && this.isOpenPrint) {
        this.$toast("请在手持机上开启打印");
        this.isOpenPrint = false;
        window.localStorage.setItem("isOpenPrint", this.isOpenPrint);
        return;
      }
      if (window.framework && this.openPrint) {
        this.$dialog
          .confirm({
            title: "功能确认",
            message: "开启打印功能需要连接蓝牙，是否确认",
          })
          .then(() => {
            window.localStorage.setItem("isOpenPrint", this.isOpenPrint);
            if (!this.isOpenPrint) {
              // 断开打印机
              if (window.framework) {
                if (window.framework.isReadPrint) {
                  window.framework.isReadPrint(false);
                }
              }
            } else {
              //手持机上才允许 连接打印机
              if (window.framework) {
                if (window.framework.isReadPrint) {
                  window.framework.isReadPrint(true);
                }
              }
            }
          })
          .catch(() => {
            this.openPrint = false;
            window.localStorage.setItem("OpenPrint", this.openPrint);
          });
      }
    },
    active(val) {
      window.localStorage.setItem("PassengersActive", val);
    },
    phoneNum(val) {
      if (val) {
        this.phoneReservation = val;
      }
    },
    passengerCardType(val) {
      window.localStorage.setItem("PassengerCardType", val);
      if (val == "居民身份证") {
        this.CodeSign = 1;
      } else if (val == "港澳台证件") {
        this.CodeSign = 2;
      } else if (val == "护照") {
        this.CodeSign = 3;
      } else if (val == "其它") {
        this.CodeSign = 4;
      } else if (val == "外国人永居证") {
        this.CodeSign = 5;
      }
    },
    passengerInfoList(val) {
      this.adultList = [];
      this.childList = [];
      var fullArr = [];
      var halfArr = [];
      var offerArr = [];
      var freeArr = [];
      var stationArr = [];
      var roundTripArr = [];
      var backTripArr = [];
      var studentArr = [];
      var militaryOrDisabilityTripArr = [];
      var customPriceTripArr = [];
      if (this.passengerInfoList.length < 1) {
        this.FullTicketNum = 0;
        this.HalfTicketNum = 0;
        this.OfferTicketNum = 0;
        this.FreeTicketNum = 0;
        this.StationTicketNum = 0;
        this.RoundTripTicketNum = 0;
        this.BackTripTicketNum = 0;
        this.StudentTicketNum = 0;
        this.MilitaryOrDisabilityPriceTicketNum = 0;
        this.CustomPriceTicketNum = 0;
      }
      for (var i = 0; i < val.length; i++) {
        if (val[i].ticketTypeName != "免") {
          this.adultList.push(val[i]);
        } else {
          this.childList.push(val[i]);
        }
        if (this.adultList < this.childList) {
          this.$toast("免票数不能多余其它类型票数量的总和");
          this.passengerInfoList = [];
        }

        // 渲染不同类型票的张数
        if (val.length > 0) {
          if (val[i].ticketTypeName == "全") {
            fullArr.push(val[i]);
            this.FullTicketNum = fullArr.length;
          }
          if (val[i].ticketTypeName == "半") {
            halfArr.push(val[i]);
            this.HalfTicketNum = halfArr.length;
          }
          if (val[i].ticketTypeName == "优") {
            offerArr.push(val[i]);
            this.OfferTicketNum = offerArr.length;
          }
          if (val[i].ticketTypeName == "免") {
            freeArr.push(val[i]);
            this.FreeTicketNum = freeArr.length;
          }
          if (val[i].ticketTypeName == "站务") {
            stationArr.push(val[i]);
            this.StationTicketNum = stationArr.length;
          }
          if (val[i].ticketTypeName == "双程") {
            roundTripArr.push(val[i]);
            this.RoundTripTicketNum = roundTripArr.length;
          }
          if (val[i].ticketTypeName == "回程") {
            backTripArr.push(val[i]);
            this.BackTripTicketNum = backTripArr.length;
          }
          if (val[i].ticketTypeName == "学生") {
            studentArr.push(val[i]);
            this.StudentTicketNum = studentArr.length;
          }
          if (val[i].ticketTypeName == "军残") {
            militaryOrDisabilityTripArr.push(val[i]);
            this.MilitaryOrDisabilityPriceTicketNum =
              militaryOrDisabilityTripArr.length;
          }
          if (val[i].ticketTypeName == "自定义") {
            customPriceTripArr.push(val[i]);
            this.CustomPriceTicketNum =
              customPriceTripArr.length;
          }
        }
      }
      this.setPassengerInfoListCache(val);
    },
    childList(val) {
      // 童票不能大于 车座位数/10
      let len = this.seatData.length;
      if (val.length > parseInt(len / 10)) {
        this.$toast("免票数超出录入范围");
        this.passengerInfoList = [];
        this.FreeTicketNum = 0;
      }
    },
  },
  created() {
    this.getTicketTypeRight();

    var ua = navigator.userAgent.toLowerCase();
    //判断是否微信内置浏览器环境
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.$http
        .post(
          "https://wx.open.class.busboss.cn/Weixin/JSAPI",
          this.$qs.stringify({
            url: encodeURIComponent(window.location.href.split("#")[0]),
            AppID: "wx5e2cde762ffa2228",
          })
        )
        .then(function (e) {
          var t = e;
          if (t) {
            // eslint-disable-next-line no-undef
            wx.config({
              debug: !1,
              appId: t.appId,
              timestamp: parseInt(t.timestamp),
              nonceStr: t.noncestr,
              signature: t.signature,
              jsApiList: ["scanQRCode"],
            });
          }
        });
    }
  },
  destroyed() {
    this.CardInfo = null;
    if (window.framework) {
      if (window.framework.isReadCard) {
        window.framework.isReadCard(false);
      }
      // 断开打印机
      if (window.framework.isReadPrint) {
        window.framework.isReadPrint(false);
      }
      if (window.framework.isReadScanner) {
        //关闭扫描头
        window.framework.isReadScanner(false);
      }
    }
  },
};
</script>

<style scoped lang="less">
[v-cloak] {
  display: none !important;
}

.InputPassengers /deep/ .van-tabs {
  z-index: 0;
}

#canvasImgDiv {
  position: absolute;
  left: -10000px;
  top: -1000px;
}

.InputPassengers {
  width: 100%;
  height: auto;

  .title {
    width: 100%;
    height: auto;
    font-size: 0.4rem;
    padding: 0.2rem 0;

    .name {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0 0.4rem;
      box-sizing: border-box;
      font-size: 0.5rem;
      display: flex;
      justify-content: space-between;

      span {
        width: 40%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .row {
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      margin-top: 0.2rem;
    }
  }

  .ticketType {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 0 0.4rem 0.2rem 0.4rem;
    box-sizing: border-box;

    .wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .block {
        flex: 1;
        height: 2rem;
        display: flex;
        justify-content: space-between;
        font-size: 0.4rem;
        background-color: #fff;
        text-align: center;
        box-sizing: border-box;

        span {
          flex: 1;
          line-height: 1.6rem;
          padding: 0.2rem;
          box-sizing: border-box;
        }

        span:nth-child(1) {
          flex: 0.2;
          font-size: 0.5rem;
          color: #111;
        }

        span:nth-child(2) {
          flex: 0.3;
          font-size: 0.4rem;
          color: red;
        }

        span:nth-child(3) {
          flex: 0.5;
          font-size: 0.5rem;
          color: #ffb870;
        }
      }

      .block:nth-child(2) {
        margin-left: 0.4rem;
      }

      .block:nth-child(3),
      .block:nth-child(4) {
        margin-top: 0.4rem;
      }

      .block.active {
        border: 1px solid red;
        box-sizing: border-box;
      }
    }

    .wrap:last-child {
      .block:nth-child(1),
      .block:nth-child(2) {
        margin-top: 0.4rem;
      }
    }
  }

  .checkCar {
    width: 100%;
    height: 7.2rem;
    padding: 0.4rem 0;
    background-color: #fff;
    box-sizing: border-box;

    p:first-child {
      font-size: 0.5rem;
      margin-top: 1rem;
    }

    p:nth-child(2) {
      font-size: 0.5rem;
      margin-top: 0.8rem;
      color: #ffb870;
    }

    p:last-child {
      font-size: 0.5rem;
      margin-top: 2rem;
    }
  }

  .handle {
    // height: 7.2rem;
    .title {
      font-size: 0.4rem;
    }

    .block {
      .row {
        width: 100%;
        padding: 0 0.2rem;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        background-color: #fff;
        border-bottom: 1px solid #eee;
        font-size: 0.4rem;

        label {
          width: 100%;
          display: flex;
          justify-content: space-between;

          span {
            display: inline-block;
          }

          input {
            border: none;
            color: #999;
            flex: 1;
            margin-left: 0.4rem;
            text-align: left;
            position: relative;
            height: 0.96rem;
          }

          select {
            position: relative;
            top: 0.1rem;
            height: 0.8rem;
          }
        }
      }

      .row:last-child {
        border: none;
      }
    }

    // 录入 重置按钮
    .btnWrap {
      width: 100%;
      height: auto;
      margin-top: 0.36rem;
      display: flex;
      justify-content: space-between;
      font-size: 0.4rem;
      color: #fff;

      .add {
        flex: 1;
        height: 1rem;
        line-height: 1rem;
        background-color: rgba(31, 189, 16, 0.733);
      }

      .reset {
        flex: 1;
        height: 1rem;
        line-height: 1rem;
        background-color: #f7a33c;
      }
    }
  }

  .passengerInfo {
    width: 100%;
    height: auto;

    .title {
      font-size: 0.5rem;
      position: relative;
      text-align: left;
      padding-left: 0.5rem;

      .title-2 {
        position: absolute;
        right: 1.9rem;
        z-index: 0;
      }

      .switch {
        position: absolute;
        top: 0.24rem;
        right: 0.8rem;
        z-index: 0;
      }
    }

    .wrap {
      width: 100%;
      padding: 0 2rem 0.4rem 2rem;
      box-sizing: border-box;
      font-size: 0.4rem;
      background-color: #fff;
      padding-top: 0.4rem;

      .block {
        width: 100%;
        height: 2rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        background-color: #fff;
        position: relative;

        .left {
          width: 2rem;
          line-height: 2rem;
          background-color: rgb(57, 176, 255);
        }

        .right {
          width: 3rem;
          flex: 1;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          background-color: rgb(214, 218, 0);
          padding: 0.1rem 0.2rem;
          box-sizing: border-box;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          span:nth-child(3) {
            display: inline-block;
          }
        }

        .delete {
          position: absolute;
          right: 0.1rem;
          top: 0.1rem;
          color: #fff;
        }
      }

      .block:not(:first-child) {
        margin-top: 0.2rem;
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      background-color: #fff;
      font-size: 0.4rem;
      padding: 0.2rem 0;
      box-sizing: border-box;

      label {
        width: 100%;

        span {
          display: inline-block;
          text-align: right;
          width: 2rem;
        }

        input {
          padding-left: 0.2rem;
          box-sizing: border-box;
          height: 0.6rem;
          border: 1px solid #eee;
          margin-left: 0.2rem;
        }
      }

      label:nth-child(2) {
        margin-top: 0.4rem;
        color: #999;
      }

      label:nth-child(3) {
        margin-top: 0.4rem;
        color: #999;
      }

      label:nth-child(4) {
        margin-top: 0.4rem;
      }

      .btnWrap {
        display: flex;
        justify-content: space-between;
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;

        div {
          width: 100%;
          margin-top: 0.2rem;
          text-align: center;

          span {
            padding: 0.2rem;
            background-color: rgb(40, 145, 231);
            border-radius: 0.1rem;
            color: #fff;
            display: inline-block;
          }
        }

        .disabled {
          opacity: 0.5;
        }
      }
    }
  }

  .seatList {
    width: 100%;
    height: auto;
    overflow: hidden;

    .title {
      font-size: 0.5rem;
      position: relative;

      .switch {
        position: absolute;
        top: 0.24rem;
        right: 0.4rem;
        z-index: 0;
      }
    }

    .SeatList {
      width: 100%;
      height: 100%;
      padding: 0 0.4rem 0.4rem.4rem;
      box-sizing: border-box;
      color: #fff;

      .container {
        width: 100%;
        height: 100%;
        overflow: hidden;

        > div {
          float: left;
          width: 25%;
          height: 2.2rem;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          background-color: #999;
          border: 1px solid #eee;
          color: red;
          font-size: 0.4rem;
          font-weight: bold;

          .top {
            width: 100%;
            height: 0.6rem;
            line-height: 0.6rem;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            padding: 0 0.2rem;
            box-sizing: border-box;
          }

          .bottom {
            height: 1.4rem;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            padding: 0 0.2rem;
            box-sizing: border-box;

            span {
              width: 1.6rem;
              display: inline-block;
              overflow: hidden;
              -ms-text-overflow: ellipsis;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .current {
          border: 2px solid red;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
        }
      }
    }
  }

  .lastSaleDetails {
    width: 2rem;
    height: auto;
    position: fixed;
    right: 0.2rem;
    bottom: 4rem;
    background-color: #2891e7;
    color: #fff;
    font-size: 0.4rem;
    padding: 0.1rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #eee;
    z-index: 2;
  }

  .SaleDetailsShow {
    width: 100%;
    height: auto;
    padding: 0.2rem 1rem;
    box-sizing: border-box;
    font-size: 0.4rem;
    background-color: transparent;

    .SaleDetailsShowTab {
      > div {
        width: 100%;
        height: 10rem;
        padding: 0.2rem;
        box-sizing: border-box;
        overflow-y: scroll;
        background-color: #fff;

        > div {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          padding: 0.1rem 0;
          box-sizing: border-box;

          > .left {
            width: 3rem;
            text-align: left;
          }

          > .right {
            flex: 1;
            text-align: right;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }

    .repeatPrint {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      color: #fff;
      display: flex;
      justify-content: space-between;

      span {
        display: inline-block;
        width: 50%;
        background-color: #2891e7;
      }

      span:nth-child(2) {
        display: inline-block;
        width: 50%;
        background-color: orange;
      }
    }
  }
}

.btn-ocr {
  position: absolute;
  top: 0.09rem;
  right: 0.2rem;
  border: 2px solid #07c160;
  z-index: 999;
  height: 0.7rem;
  line-height: 0.76rem;
  padding: 0 0.3rem;
  color: #07c160;
  border-radius: 0.16rem;
  background-color: #fff;
}

.ticket-type {
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 5px));
  grid-gap: 10px;
  padding: 0 10px;
  .ticket-type-item {
    background-color: #fff;
    display: flex;
    font-size: 0.45rem;
    position: relative;
    .ticket-type-item-blank {
      width: 10px;
    }
    .ticket-type-item-info {
      flex: 1;
      padding: 10px;
      .ticket-type-item-detail {
        margin-bottom: 5px;
        display: flex;
      }
      .ticket-type-item-residue {
        width: 50%;
        background-color: #07c160;
        color: #fff;
        text-align: left;
        font-size: 0.34rem;
        border-top-right-radius: 0.3rem;
        border-bottom-right-radius: 0.3rem;
      }
    }
  }
  .item-active {
    .ticket-type-item-blank {
      background-color: red !important;
    }
    .ticket-type-item-info {
      background-color: rgba(#f7a33c, 0.15);
    }
  }
  .ticket-type-is-checked::after {
    content: "";
    background-color: rgba(255, 255, 255, 0.75);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
